// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body,
#root {
  min-height: 100%;
}

:root {
  font-family: var(--ui-font-body);
  color: var(--ui-text);
}

body {
  margin: 0;
  color: var(--ui-text);
  background:
    radial-gradient(circle at 88% 8%, rgba(29, 90, 124, 0.12), transparent 44%),
    radial-gradient(circle at 10% 84%, rgba(149, 109, 21, 0.1), transparent 46%),
    linear-gradient(180deg, var(--ui-canvas-soft) 0%, var(--ui-canvas) 100%);
}

.app-shell {
  width: min(var(--ui-shell-max-width), calc(100% - (var(--ui-shell-gutter) * 2)));
  margin: 0 auto;
}

h1,
h2,
h3 {
  font-family: var(--ui-font-display);
  letter-spacing: 0.01em;
}

input,
select,
textarea,
button {
  font-family: inherit;
}

::selection {
  background: rgba(29, 90, 124, 0.24);
}
`, "",{"version":3,"sources":["webpack://./src/styles/base.css"],"names":[],"mappings":"AAAA;;;EAGE,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,qBAAqB;EACrB;;;4EAG0E;AAC5E;;AAEA;EACE,gFAAgF;EAChF,cAAc;AAChB;;AAEA;;;EAGE,mCAAmC;EACnC,sBAAsB;AACxB;;AAEA;;;;EAIE,oBAAoB;AACtB;;AAEA;EACE,mCAAmC;AACrC","sourcesContent":["html,\nbody,\n#root {\n  min-height: 100%;\n}\n\n:root {\n  font-family: var(--ui-font-body);\n  color: var(--ui-text);\n}\n\nbody {\n  margin: 0;\n  color: var(--ui-text);\n  background:\n    radial-gradient(circle at 88% 8%, rgba(29, 90, 124, 0.12), transparent 44%),\n    radial-gradient(circle at 10% 84%, rgba(149, 109, 21, 0.1), transparent 46%),\n    linear-gradient(180deg, var(--ui-canvas-soft) 0%, var(--ui-canvas) 100%);\n}\n\n.app-shell {\n  width: min(var(--ui-shell-max-width), calc(100% - (var(--ui-shell-gutter) * 2)));\n  margin: 0 auto;\n}\n\nh1,\nh2,\nh3 {\n  font-family: var(--ui-font-display);\n  letter-spacing: 0.01em;\n}\n\ninput,\nselect,\ntextarea,\nbutton {\n  font-family: inherit;\n}\n\n::selection {\n  background: rgba(29, 90, 124, 0.24);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
